// extracted by mini-css-extract-plugin
export default {"ReviewContainer":"ReviewContainer_ReviewContainer__jOFGs","SwiperContainer":"ReviewContainer_SwiperContainer__Jxn+m"};